import { render, staticRenderFns } from "./logpuerta.vue?vue&type=template&id=2b3a5b80&"
import script from "./logpuerta.vue?vue&type=script&lang=js&"
export * from "./logpuerta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports